import { getTextFieldHelperTextAndError } from "./getTextFieldHelperTextAndError";

/**
 * @param {*} formik
 * @param {*} key
 * @returns
 */
export function getTextFieldProps(formik: any, key: string) {
    return {
        ...formik.getFieldProps(key),
        ...getTextFieldHelperTextAndError(formik, key),
    };
}
